import React from 'react';
import { storiesOf } from '@storybook/react';
import Calendar, { CalendarProps } from '..';
import { SupportedWixLocales } from 'wix-design-systems-locale-utils';
import { clickElement, focusElement } from '../../../../test/visualTestUtils';

const dataHook = 'calendar';
const previousMonthButtonDataHook = 'datepicker-left-arrow';

class CalendarWrapper extends React.PureComponent<{
  componentDidMount: () => void;
}> {
  componentDidMount() {
    const { componentDidMount } = this.props;
    componentDidMount && componentDidMount();
  }

  render() {
    const { componentDidMount, ...props } = this.props;
    return (
      <Calendar dataHook={dataHook} onChange={() => undefined} {...props} />
    );
  }
}

const commonTests: {
  it: string;
  props: Partial<CalendarProps>;
  componentDidMount?: () => void;
}[] = [
  {
    it: 'should correctly render when selectedDays is a single date',
    props: {
      value: new Date('2017/05/01'),
    },
  },
  {
    it: 'should correctly render when previous month button is clicked',
    props: {
      value: new Date('2017/06/05'),
    },
    componentDidMount: () => {
      clickElement(previousMonthButtonDataHook);
      focusElement(previousMonthButtonDataHook);
    },
  },
  {
    it: 'FilterDate - Prior for today dates (includes today)',
    props: {
      value: new Date('2020/10/10'),
      filterDate: (date) => date <= new Date('2020/10/10'),
    },
  },
  {
    it: 'FilterDate - feature dates only (includes today)',
    props: {
      value: new Date('2020/10/10'),
      filterDate: (date) => date >= new Date('2020/10/10'),
    },
  },
  {
    it: 'Months dropdown',
    props: {
      value: new Date('2020/10/10'),
      showMonthDropdown: true,
    },
  },
  {
    it: 'Years dropdown',
    props: {
      value: new Date('2020/10/10'),
      showYearDropdown: true,
    },
  },
  {
    it: 'Months and years dropdown',
    props: {
      value: new Date('2020/10/10'),
      showMonthDropdown: true,
      showYearDropdown: true,
    },
  },
  ...SupportedWixLocales
    .filter((locale) => ['ja', 'zh', 'ko'].includes(locale))
    .map((locale) => ({
      it: `Flips months and years dropdowns in ${locale}`,
      props: {
        value: new Date('2020/10/10'),
        showMonthDropdown: true,
        showYearDropdown: true,
        locale,
      },
    })),
  {
    it: 'Date Indication',
    props: {
      value: new Date('2020/10/8'),
      showMonthDropdown: true,
      showYearDropdown: true,
      dateIndication: ({ date }) =>
        date <= new Date('2020/10/10') ? (
          <div
            className="Indications"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              className="indication"
              style={{
                borderRadius: '50%',
                width: '4px',
                height: '4px',
                backgroundColor: 'black',
              }}
            />
          </div>
        ) : null,
    },
  },
  {
    it: 'Should indicate custom today',
    props: {
      value: new Date('2020/10/10'),
      today: new Date('2020/10/12'),
    },
  },
  {
    it: 'should render outside days',
    props: { value: new Date('2025/2/1'), showOutsideDays: true },
  },
  {
    it: 'should not render 6 fixed weeks',
    props: {
      value: new Date('2025/2/1'),
      fixedWeeks: false,
      showOutsideDays: true,
    },
  },
];

const tests = [
  {
    describe: 'Calendar',
    its: commonTests,
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props, componentDidMount }) => {
    storiesOf(describe, module).add(it, () => (
      <CalendarWrapper {...props} componentDidMount={componentDidMount} />
    ));
  });
});
